import { render } from "./InterviewDetails.vue?vue&type=template&id=779271c4&scoped=true"
import script from "./InterviewDetails.vue?vue&type=script&lang=js"
export * from "./InterviewDetails.vue?vue&type=script&lang=js"

import "./InterviewDetails.vue?vue&type=style&index=0&id=779271c4&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779271c4"]])

export default __exports__